<template>
  <!-- 转长期维护详情 -->
  <div class="transfer-long-time-detail record-detail" v-loading="loading">
    <div
      v-if="(showFormFieldKeyInfo.apply_reason_formCode_FR006 || {}).isShow"
      class="info-row
    ">
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.apply_reason_formCode_FR006.zhName }}</span>
        <span class="row-value">{{ formData.apply_reason_formCode_FR006 || '-' }}</span>
      </div>
    </div>
    <div
      v-if="(showFormFieldKeyInfo.expired_formCode_FR006 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.expired_formCode_FR006.zhName }}</span>
        <span class="row-value">{{ formData.expired_formCode_FR006 || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const transferFormCode = 'FR006' // 转长期维护表单编码

export default {
  name: 'TransferLongTimeDetail',
  data() {
    return {
      loading: false,
      originOptionsInfo: {},
      showFormFieldKeyInfo: {},
      formData: {
        apply_reason_formCode_FR006: '', // 申请原因
        expired_formCode_FR006: '', // 截止时间
      },
    }
  },
  methods: {
    async init(formCodeList) {
      this.loading = true
      try {
        await this.getFormFieldList(formCodeList)
        await this.getFormData(formCodeList)
      } catch (error) {
        console.error('获取表单字段配置信息失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList(formCodeList = []) {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo
      } = await formFlow.getFormFieldList(formCodeList)

      this.formData = formData
      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取表单数据
    async getFormData(formCodeList = []) {
      const { formData } = this
      for (const formCode of formCodeList) {
        const data = await formFlow.getFormData({
          instanceId: this.currentRecordInfo.doctorStageId,
          stepCode: this.currentRecordInfo.stepCode,
          stepId: this.currentRecordInfo.stepId,
          formCode,
          doctorId: this.currentRecordInfo.doctorId,
          interfaceType: 'stepId'
        })
        // console.log('获取详情页面表单页面数据', data)
      
        // 表单获取的数据为空，则初始化表单id
        if (utils.getDataType(data) === 'object' && Object.keys(data.formData).length === 0) {
          continue
        }

        for(const key in data.formData) {
          const item = data.formData[key] || {}
          const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
          if ([1, 2].includes(item.inputType)) {
            // 单选/多选
            formData[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
          } else {
            formData[key] = valueList[0] || formData[key] || ''
          }
        }
        this.formData = formData
      }
    },
  },
  created() {
    const formCodeList = [transferFormCode]
    this.init(formCodeList)
  },
  props: {
    currentRecordInfo: {
      type: Object,
      default: () => ({})
    }
  }
}

</script>

<style scoped lang='less'>
@import '~@/views/DoctorVisitLTC/style/recordDetail.less';
</style>